import type { ReactNode } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

const emptyHintVariants = cva(
  'rounded-md border border-dashed border-border-soft px-4 text-center text-meta text-faint-foreground',
  {
    variants: {
      density: {
        default: 'py-10',
        compact: 'py-6 px-2.5',
      },
    },
    defaultVariants: { density: 'default' },
  },
);

type EmptyHintDensity = NonNullable<VariantProps<typeof emptyHintVariants>['density']>;

interface EmptyHintProps {
  children: ReactNode;
  density?: EmptyHintDensity;
  testId?: string;
  className?: string;
}

/**
 * EmptyHint — dashed-bordered placeholder box used inside a column,
 * tab body or drawer slot when the underlying list is empty. Single
 * muted message, locked padding. For richer empty states with an
 * icon + title + sub block, prefer a per-feature component instead.
 */
export function EmptyHint({
  children,
  density,
  testId,
  className,
}: Readonly<EmptyHintProps>): React.JSX.Element {
  return (
    <div data-testid={testId} className={emptyHintVariants({ density, className })}>
      {children}
    </div>
  );
}
